import TourBookingDetailsReducer from "Tour-Admin/Redux/Reducers/BookingDetailsReducer";
import TourCustomerBookingDetailReducer from "Tour-Customer/Redux/Reducer/BookingDetailReducer";
import TourCustomerReducer from "Tour-Admin/Redux/Reducers/CustomerReducer";
import TourPaymentsListReducer from "Tour-Admin/Redux/Reducers/PaymentsListReducer";
import TourPaymentDetailsReducer from "Tour-Admin/Redux/Reducers/PaymentDetailsReducer";
import TourLandingReducer from "Tour-Customer/Redux/Reducer/TourLandingReducer";
import TourFaqReducer from "Tour-Customer/Redux/Reducer/TourFaqReducer";


export const reducerList = {
  TourCustomerBookingDetailReducer: TourCustomerBookingDetailReducer,
  TourBookingDetailsReducer:TourBookingDetailsReducer,
  TourCustomerReducer:TourCustomerReducer,
  TourPaymentsListReducer:TourPaymentsListReducer,
  TourPaymentDetailsReducer:TourPaymentDetailsReducer,
  TourLandingReducer:TourLandingReducer,
  TourFaqReducer:TourFaqReducer
}
